import { Permission } from "src/app/views/wrapper/payroll/company/setting/settings";

export enum ROLE {
  PIGASUS = 0,
  SUPERADMIN,
  ADMIN
}

export interface COMPANYLIST {
  id: string;
  name?: string;
  logo?: string;
  permission_list?: Permission[]
}

export interface User {
  email: string;
  role: ROLE;
  companies: COMPANYLIST[];
}

export interface UserPermission {
  email: string
  role: ROLE
  permission_list?: Permission[]
  isPigasus: boolean
  isAdmin: boolean
}